import type { FC } from "react";
import { optimizeImageUrl } from "~/lib/imageUtils";
import type { ProductSlide } from "~/lib/productSlides";
import { productImageSrc } from "~/lib/productSlides";
import WvFileCarouselPlayer from "./WvFileCarouselPlayer";
import WvYoutubeCarouselPlayer from "./WvYoutubeCarouselPlayer";

/** One slide of the product carousel: image, YouTube video or video file. */
const WvProductCarouselSlide: FC<{
  slide: ProductSlide;
  active: boolean;
  priority?: boolean;
}> = ({ slide, active, priority = false }) => {
  if (slide.kind === "image") {
    return (
      <div className="product-viewport__img-wrapper">
        <img
          className="product-viewport__img"
          src={optimizeImageUrl(productImageSrc(slide.image))}
          alt={slide.image.altText || ""}
          loading={priority ? undefined : "lazy"}
          fetchPriority={priority ? "high" : undefined}
        />
      </div>
    );
  }

  return (
    <div className="product-viewport__img-wrapper position-relative">
      {slide.kind === "youtube" ? (
        <WvYoutubeCarouselPlayer
          videoId={slide.id}
          title={slide.title}
          active={active}
        />
      ) : (
        <WvFileCarouselPlayer
          src={slide.src}
          title={slide.title}
          active={active}
        />
      )}
    </div>
  );
};

export default WvProductCarouselSlide;
